import loadingAnim1 from "../../images/loading.svg";
import loadingAnim2 from "../../images/blocks-shuffle-4.svg";

export default function Loading({
  text,
  little,
  variant = 0,
}: {
  text: String | React.ReactElement;
  little?: boolean;
  variant?: number;
}) {
  return (
    <div className="loading">
      <div>
        <img
          src={!variant ? loadingAnim1 : loadingAnim2}
          style={
            little
              ? {
                  boxShadow: "0 0 5px orange",
                  borderRadius: "50%",
                  width: "18px",
                }
              : variant === 1
                ? {
                    width: "42px",
                    padding:"8px"
                  }
                : {}
          }
        />
        <div>{text}</div>
      </div>
    </div>
  );
}
